import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 160,
    height: 'auto',
    maxHeight: 32,
    objectFit: 'contain',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      src="/LogoFull.svg"
      alt="Deuna"
      className={classes.img}
    />
  );
};

export default LogoFull;
